module.exports = __webpack_public_path__ + "static/ray-manista.29d12d2f.webp";